<template>
  <div class="innerPage">
    <div class="innerPageHead">
      <div class="innerPageTitle">
        <h2>{{ $t("TopNav07") }}</h2> 
      </div>
      <div class="innerPagePagination">
        <b-container>
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-container>
      </div>
    </div>

    <div class="interPageMainContain">
      <b-container>
        <b-row align-h="center">
          <article class="contact-card">
            <header class="contact-card__head">
              <div class="contact-card__title">{{ $t("contact_01") }}</div>
              <p class="contact-card__subtitle">{{ $t("contact_02") }}</p>
            </header>

            <div class="contact-card__body">
              <div class="contact-item">
                <div class="contact-item__icon" aria-hidden="true"><span class="icon-phone"></span></div>
                <div>
                  <span class="contact-item__label">{{ $t("contact_03") }}</span>
                  <span class="contact-item__value">
                    <a href="tel:+886424516669">{{ $t("contact_04") }}</a>
                    {{ $t("contact_05") }}
                  </span>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-item__icon" aria-hidden="true"><span class="icon-mail"></span></div>
                <div>
                  <span class="contact-item__label">{{ $t("contact_06") }}</span>
                  <span class="contact-item__value">
                    <a href="mailto:amanda@gis.tw">amanda@gis.tw</a>
                  </span>
                </div>
              </div>

              <div class="contact-actions">
                <a class="contact-button" href="mailto:amanda@gis.tw">{{ $t("contact_07") }}</a>
                <a class="contact-button contact-button--outline" href="tel:+886424516669">{{ $t("contact_08") }}</a>
              </div>
            </div>
          </article>
        </b-row>
      </b-container>


    </div>    
    <ul id="myMenu">
      <li>
        <b-link to="/" tooltip="首頁" flow="left"
          ><span class="icon-home" :title="$t('rightNav01')"></span
          ><span class="sr-only">{{ $t("TopNav01") }}</span>
        </b-link>
      </li>
      <li>
        <a
          href="https://www.surveycake.com/s/DrWBR"
          target="_blank"
          tooltip="報名論壇"
          flow="left"
          :title="$t('rightNav02-1')"
          ><span class="icon-user-plus"></span>
          <span class="sr-only">{{ $t("TopNav05") }}</span></a
        >
      </li>
      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          :title="$t('rightNav07')"
          ><span class="icon-arrow_up"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        navigationActive: [],
        items: [
          {
            text: this.$t("TopNav01") ,
            href: "#/",
          },
          {
            text: this.$t("TopNav07") ,
            active: true,
          },
        ],
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      window.addEventListener("scroll", this.updateScroll);
    },
    methods: {

    },
  };
</script>
<style lang="scss"></style>
